import { SearchResultsPresentation } from "./SearchResultsPresentation";
import { Dispatch, SetStateAction } from "react";
import { useUserPreference } from "@coworker/app/src/hooks/useProfilePreferencesQuery";
import profilePreferences from "@coworker/enums/profilePreferences";
import { Item } from "../../../shared/types/item";
import { useSearchItems } from "@coworker/apprestructured/src/scan-and-search/hooks/search/useSearchItems";
import { useCallSikSearchBox } from "@coworker/apprestructured/src/scan-and-search/hooks/search/useCallSikSearchBox";
import { useCallSikSearchBox as useCallSikSearchBoxCoworker } from "@coworker/apprestructured/src/scan-and-search/hooks/search/useCallSikSearchBoxCoworker";
import { SearchResultsSkeleton } from "@coworker/apprestructured/src/scan-and-search/components/searchResults/SearchResultsSkeleton/SearchResultsSkeleton";
import { SearchItemCardRenderType } from "@coworker/apprestructured/src/scan-and-search/types/SearchItemCardRenderType";
import useFlag, { FLAGS } from "@coworker/app/src/hooks/useFlag";

interface SearchResultsProps {
  searchQuery: string;
  setSearchQuery: Dispatch<SetStateAction<string>>;
  shouldHideSPRItems: boolean;
  shouldHideLocalCombinationItems: boolean;
  handleItemCardClick?: (item: Item) => void;
  itemCardRenderType?: SearchItemCardRenderType;
}

export const SearchResults = ({
  searchQuery,
  setSearchQuery,
  shouldHideSPRItems,
  shouldHideLocalCombinationItems,
  handleItemCardClick = () => {},
  itemCardRenderType = SearchItemCardRenderType.link,
}: SearchResultsProps) => {
  const useNewProductSearch = useFlag(FLAGS.ENABLE_NEW_PRODUCT_SEARCH);
  const useSearchBox = useNewProductSearch
    ? useCallSikSearchBoxCoworker
    : useCallSikSearchBox;

  const {
    data: searchProposals,
    isLoading: isLoadingProposals,
    isError,
  } = useSearchBox(searchQuery);

  const {
    data: items,
    isLoading,
    fetchNextPage,
    totalItems,
    isError: isErrorFetchingItems,
  } = useSearchItems(
    searchQuery,
    shouldHideSPRItems,
    shouldHideLocalCombinationItems
  );

  const [searchHistory, setSearchHistory] = useUserPreference<string[]>(
    profilePreferences.SEARCH_HISTORY,
    []
  );

  const isLoadingResults = isLoading || isLoadingProposals;

  if (isLoadingResults) {
    return <SearchResultsSkeleton />;
  } else if (!isErrorFetchingItems && items && searchProposals && !isError) {
    return (
      <SearchResultsPresentation
        proposals={searchProposals}
        items={items}
        loading={isLoading || isLoadingProposals}
        totalCount={totalItems}
        searchQuery={searchQuery}
        handleLoadMoreClick={fetchNextPage}
        setSearchQuery={setSearchQuery}
        setSearchHistory={setSearchHistory}
        handleItemCardClick={handleItemCardClick}
        itemCardRenderType={itemCardRenderType}
        searchHistory={searchHistory}
      />
    );
  } else {
    return null;
  }
};
